import { render, staticRenderFns } from "./product_add.vue?vue&type=template&id=34185c08&"
import script from "./product_add.vue?vue&type=script&lang=js&"
export * from "./product_add.vue?vue&type=script&lang=js&"
import style0 from "./product_add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports